import {useEffect, useState} from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    CircularProgress,
    FormControlLabel,
    Checkbox, FormHelperText
} from "@mui/material";
import axios from "axios";
import {quizData} from "../data/quizData";
import '../styles.css'

const API_URL = "https://totem-terna-api-574969884775.europe-west1.run.app"


export default function Quiz() {
    const [step, setStep] = useState("form"); // "form", "quiz", "feedback"
    const [formData, setFormData] = useState({ nome: "", cognome: "", email:null, societa:null, privacyAccepted:true});
    const [isFormValid, setIsFormValid] = useState(false);
    const [userId, setUserId] = useState(null);

    const [quizStep, setQuizStep] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showFeedback, setShowFeedback] = useState(false);
    const [score, setScore] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (showFeedback) {
            setTimeout(() => setAnimate(true), 100); // Avvia l'animazione con un piccolo delay
        }
    }, [showFeedback]);

    useEffect(() => {
        setIsFormValid(
            formData.nome.trim() !== ""
            //formData.cognome.trim() !== ""
            /*formData.societa.trim() !== "" &&
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
            formData.privacyAccepted*/
        );
    }, [formData]);


    const handleFormChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };


    const handleSubmitForm = async () => {
        if (!isFormValid) return;

        setIsLoading(true);
        try {
            const response = await axios.post(`${API_URL}/add`, formData);
            setUserId(response.data.id); // Salva l'ID ricevuto
            setStep("quiz");
            setIsLoading(false);
        } catch (error) {
            console.error("Errore nell'invio dei dati:", error);
            setIsLoading(false);
        }
    };

    const handleSelectOption = (index) => {
        setSelectedOption(index);
    };

    const handleConfirmAnswer = () => {
        if (selectedOption === quizData[quizStep].correct) {
            setScore(score + 1);
        }
        setAnimate(true);
        setShowFeedback(true);
    };

    const handleNextQuestion = async () => {
        if (quizStep < quizData.length - 1) {
            setQuizStep(quizStep + 1);
            setSelectedOption(null);
            setShowFeedback(false);
            setAnimate(false);
        } else {
            setStep("end");
            await sendFinalScore();
        }
    };

    const sendFinalScore = async () => {
        try {
            await axios.post(`${API_URL}/update`, {
                id: userId,
                score: score
            });
        } catch (error) {
            console.error("Errore nell'invio del punteggio:", error);
        }
    };

    const resetQuiz = () => {
        setStep("form");
        setFormData({ nome: "", cognome: "", email: "", societa: "", privacyAccepted: false });
        setUserId(null);
        setQuizStep(0);
        setSelectedOption(null);
        setShowFeedback(false);
        setScore(0);
    };


    return(
        <Box sx={{
            width:'100vw',
            height:'100vh',
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'center',
            backgroundImage:'url("/images/tablet-bkg.png")',
            backgroundSize:'cover'
        }}>
            {step === "form" && (
                <Box sx={{ display: "flex", flexDirection:'column', width: "80%", rowGap:5}}>
                    <TextField
                        fullWidth
                        name="nome"
                        placeholder={"Nome"}
                        value={formData.nome}
                        onChange={handleFormChange}
                    />
                    {/*<TextField
                        fullWidth
                        name="cognome"
                        placeholder={"Cognome"}
                        value={formData.cognome}
                        onChange={handleFormChange}
                    />*/}
                    {/*<TextField
                        fullWidth
                        placeholder={"Email"}
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleFormChange}
                    />
                    <TextField
                        fullWidth
                        placeholder={"Società"}
                        name="societa"
                        value={formData.societa}
                        onChange={handleFormChange}
                    />
                    <Box>
                        <FormControlLabel
                            control={<Checkbox checked={formData.privacyAccepted} onChange={handleCheckboxChange} sx={{ color: "white" }} />}
                            label={<Typography sx={{ color: "white" }}>Dichiaro di aver letto e capito la privacy policy.</Typography>}
                            sx={{ width: "80%", mt: 1 }}
                        />
                    </Box>*/}
                    <Box sx={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', minHeight:'120px'}}>
                        {isLoading ?
                            <CircularProgress sx={{color:'white'}}/>
                            :
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{ width: "50%", mt: 2 }}
                                onClick={handleSubmitForm}
                                disabled={!isFormValid}
                            >
                                CONFERMA
                            </Button>
                        }

                    </Box>
                </Box>
            )}

            {step === "quiz" && !showFeedback && (
                <Box sx={{ p: 3, width: '100%', display:'flex', flexDirection:'column', justifyContent:'flex-start', alignItems:'left', height:'100%', padding:'64px', rowGap:3 }}>
                    <Typography variant="h1" mb={2} fontWeight={'300'}>{quizData[quizStep].index}.</Typography>
                    <Typography variant="h4" mb={2} fontWeight={'bold'}>{quizData[quizStep].question}</Typography>
                    <Box sx={{overflowY:'auto', height:'45%', display:'flex', flexDirection:'column', rowGap:3}}>
                        {quizData[quizStep].options.map((option, index) => (
                            <FormControlLabel
                                onClick={() => handleSelectOption(index)}
                                key={index}
                                control={
                                    <Box
                                        sx={{
                                            marginLeft:'10px',
                                            marginTop:'10px',
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: selectedOption === index ? '#4fadff' : '#fff',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s',
                                            flexShrink: 0
                                        }}
                                    >

                                    </Box>
                                }
                                label={
                                    <Typography
                                        sx={{
                                            fontSize: '2rem',
                                            color: selectedOption === index ? '#4fadff' : 'text.primary',
                                            fontWeight: selectedOption === index ? 'bold' : 'normal',
                                            marginLeft: 2,
                                            whiteSpace: 'pre-wrap',
                                            textAlign:'left'
                                        }}
                                    >
                                        {option}
                                    </Typography>
                                }
                                sx={{
                                    display: 'flex',  // Usa display flex per allineare il quadrato e il testo orizzontalmente
                                    alignItems: 'flex-start', // Allinea la parte superiore del quadrato e del testo
                                }}
                            />
                        ))}
                    </Box>

                    <Box sx={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', minHeight:'120px'}}>
                        <Button
                            variant="contained"
                            sx={{ mt: 0, width:'50%' }}
                            onClick={handleConfirmAnswer}
                            disabled={selectedOption === null}
                        >
                            CONFERMA
                        </Button>
                    </Box>
                </Box>
            )}

            {step === "quiz" && showFeedback && (
                <Box sx={{ p: 3, width: '100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'left', height:'100%', padding:'64px' }}>
                    <Box sx={{ p: 3, width: '100%', display:'flex', flexDirection:'column', justifyContent:'space-evenly', alignItems:'left', height:'80%',rowGap:3, border:'2px solid #fff', backgroundColor:'#005ca9' }}>
                        <Box sx={{width:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                            <Box className={animate ? "animated-border" : ""} sx={{width: '150px', height: '150px', border:'2px solid #fff', display:'flex'}}>
                                <img
                                    src={selectedOption === quizData[quizStep].correct ? "/icons/V.png" : "/icons/X.png"}
                                    className={animate ? "fade-in" : ""}
                                    style={{
                                        width:'90px',
                                        margin: 'auto',
                                        opacity: 0,
                                        transform: "scale(0.5)",
                                        transition: "opacity 2s ease-out 2s, transform 2s ease-out 2s",
                                    }}
                                />
                            </Box>

                            <Typography
                                variant="h4"
                                mb={5}
                                mt={2}
                                className={animate ? "slide-up" : ""}
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    fontWeight:'bold',
                                    opacity: 0,
                                    transform: "translateY(20px)",
                                    transition: "opacity 0.5s ease-out 0.8s, transform 0.5s ease-out 0.8s",
                                }}>
                                {selectedOption === quizData[quizStep].correct ? "Corretto" : "Sbagliato"}
                            </Typography>

                        </Box>

                        <Typography variant="h6" sx={{width: '100%', textAlign: 'center'}}>
                            {quizData[quizStep].explanation}
                        </Typography>
                        <Box sx={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', minHeight:'120px'}}>
                            <Button variant="contained" sx={{ mt: 0, width:'50%' }} onClick={handleNextQuestion}>
                                {quizStep < quizData.length - 1 ? "AVANTI" : "Fine quiz"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}

            {step === "end" && (
                <Box sx={{ p: 3, minWidth: 300, height:'50%', display:'flex', flexDirection:'column', alignItems:'center' }}>
                        <Typography variant="h3" fontWeight={'bold'} textAlign={'center'}>GRAZIE PER AVER GIOCATO!</Typography>
                        <Typography variant="h4" mt={5} fontWeight={'bold'} textAlign={'center'}>Guarda sul monitor il tuo <br/> punteggio.</Typography>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ mt: 'auto', backgroundColor:'#fff', color:'#005ca9', fontSize:'32px', width:'fit-content' }}
                            onClick={resetQuiz}
                        >
                            GIOCA DI NUOVO
                        </Button>
                </Box>
            )}
        </Box>
    )
}